

















import { defineComponent, ref, PropType } from '@vue/composition-api';
import TreeNodeHoverEstimate from '../tree-node-hover-estimate/index.vue';
import { props as compProps } from '../tree-node-hover-estimate/consts';

const name = 'ttam-tree-node-hover-estiamte-popover';

export default defineComponent({
  name,
  components: { TreeNodeHoverEstimate },
  props: compProps,
  setup(props, ctx) {
    const hoverEstimateRef = ref();
    function onShowHoverEstimate() {
      ctx.emit('show', props.nodeData);
      hoverEstimateRef?.value?.showHoverEstimate?.(props.nodeData);
    }

    return {
      name,
      onShowHoverEstimate,
      hoverEstimateRef,
    };
  },
});
